<div id="manual-diagnoses">
    <accordion #accordion class="lv1-accordion" [closeOthers]="true">
        <accordion-group [class.lv1-selected]="currentEditDiagnosis && currentEditDiagnosis.id === category.id" *ngFor="let category of diagnosisList;" [isOpen]="currentEditDiagnosis && currentEditDiagnosis.category && currentEditDiagnosis.category.id === category.id">
            <div class="diagnosis" accordion-heading>
                <ng-container *ngIf="!category.is_no_diagnosis">
                    <div id="diagnosis-{{ category.id }}" class="diagnosis--text">
                        <strong>{{ category['code'] }} - </strong>{{ category['name_' + translate.currentLang] }}
                    </div>
                    <button class="btn btn-link pull-right" *ngIf="category.children.length > 0">
                        <i class="fas" [ngClass]="{'fa-angle-down': !category.isCollapsed, 'fa-angle-up': category.isCollapsed}" aria-hidden="true"></i>
                    </button>
                </ng-container>
                <ng-container *ngIf="category.is_no_diagnosis">
                    <div id="diagnosis-{{ category.id }}" class="diagnosis--text">
                        {{ category['name_' + translate.currentLang] }}
                    </div>
                    <button *ngIf="selectedDiagnosisIds.indexOf(category.id) >= 0; else removeBtn" class="btn btn-link diagnosis--btn" (click)="remove(category)">
                        {{ 'Remove' | translate}}
                    </button>
                    <ng-template #removeBtn>
                        <button class="btn btn-link diagnosis--btn" (click)="add(category)">
                            {{ 'Add' | translate}}
                        </button>
                    </ng-template>
                </ng-container>
            </div>
            <accordion class="lv2-accordion" [closeOthers]="true">
                <accordion-group [class.lv2-selected]="currentEditDiagnosis && currentEditDiagnosis.id === subcategory.id"  *ngFor="let subcategory of category.children" [isOpen]="currentEditDiagnosis && currentEditDiagnosis.subcategory && currentEditDiagnosis.subcategory.id === subcategory.id">
                    <div class="diagnosis" accordion-heading>
                        <button *ngIf="subcategory.children.length > 0; else emptyIcon" class="btn btn-link diagnosis--dropdown">
                            <i class="fas" [ngClass]="{'fa-angle-down': !subcategory.isCollapsed, 'fa-angle-up': subcategory.isCollapsed}" aria-hidden="true"></i>
                        </button>
                        <ng-template #emptyIcon>
                            <button class="btn btn-link diagnosis--dropdown invisible">
                                <i class="fas fa-plus fa-lg" aria-hidden="true"></i>
                            </button>
                        </ng-template>
                        <div id="diagnosis-{{ subcategory.id }}" class="diagnosis--text">
                            <span>{{ subcategory['code'] }} - {{  subcategory['name_' + translate.currentLang] }}</span>
                            <span class="duplication-text" *ngIf="subcategory.id !== openedDiagnosisId && subcategory.alreadySelected">&nbsp;({{ 'This diagnosis is already selected' | translate }})</span>
                        </div>
                        <button *ngIf="selectedDiagnosisIds.indexOf(subcategory.id) >= 0; else removeBtn" class="btn btn-link diagnosis--btn" (click)="remove(subcategory);$event.stopPropagation();">
                            {{ 'Remove' | translate}}
                        </button>
                        <ng-template #removeBtn>
                            <button class="btn btn-link diagnosis--btn" (click)="add(subcategory);$event.stopPropagation();">
                                {{ 'Add' | translate}}
                            </button>
                        </ng-template>
                    </div>
                    <div class="panel-heading lv2-heading" [class.lv3-selected]="currentEditDiagnosis && currentEditDiagnosis.id === diagnosis.id" *ngFor="let diagnosis of subcategory.children">
                        <div class="diagnosis">
                            <div id="diagnosis-{{ diagnosis.id }}" class="diagnosis--text">
                                <span>{{ diagnosis['code'] }} - {{ diagnosis['name_' + translate.currentLang] }}</span>
                                <span *ngIf="diagnosis.id !== openedDiagnosisId && diagnosis.alreadySelected">&nbsp;({{ 'This diagnosis is already selected' | translate }})</span>
                            </div>
                            <button *ngIf="selectedDiagnosisIds.indexOf(diagnosis.id) >= 0; else removeBtn" class="btn btn-link diagnosis--btn" (click)="remove(diagnosis)">
                                {{ 'Remove' | translate}}
                            </button>
                            <ng-template #removeBtn>
                                <button class="btn btn-link diagnosis--btn" (click)="add(diagnosis)">
                                    {{ 'Add' | translate}}
                                </button>
                            </ng-template>
                        </div>
                    </div>
                </accordion-group>
            </accordion>
        </accordion-group>
    </accordion>
</div>

